<div class="">
  <button
    mat-icon-button
    matSuffix
    class="close"
    (click)="closePopup()"
  >
    <mat-icon>close</mat-icon>
  </button>
  <span class="title">Upload Failed!</span>
  <span class="detail"
    >Upload Failed, please refer the downloaded log for the error.</span
  >
</div>